import h from "../core/createElement";

export default function Btn({ title = "", icon = '', color = "", onClick, name = "", shared = {}, disabled, containerClass }) {
    let is_disabled = disabled ?? false;

    const btn = (
        <button class={"btn " + (color ? color : "") + (is_disabled ? " disabled" : "") + (containerClass ? (" " + containerClass) : "")} onClick={e => !is_disabled && (onClick && onClick(e))}>
            {title && <label>{title}</label>}
            {icon && <img src={icon} />}
        </button>
    )

    if (name && shared) {
        shared[name] = {
            element: btn,
            disable: () => { btn.classList.add("disabled"); is_disabled = true },
            enable: () => { btn.classList.remove("disabled"); is_disabled = false }
        };
    };

    return btn;
};